export default __webpack_public_path__ + "static/media/Neophyte's Armbands of the Mandate.504c6a7a.jpg";